function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var React = require('react');

var React__default = _interopDefault(React);

var amplitude = require('@amplitude/analytics-browser');

var pluginWebAttributionBrowser = require('@amplitude/plugin-web-attribution-browser');

var experimentJsClient = require('@amplitude/experiment-js-client');

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function get(obj, path) {
  if (!obj) return undefined;
  var fullPath = path.replace(/\[/g, '.').replace(/]/g, '').split('.').filter(Boolean);
  var exists = fullPath.every(function (step) {
    return !(step && (obj = obj[step]) === undefined);
  });
  return exists ? obj : undefined;
}

var withDefault = function withDefault(value, defaultValue) {
  return typeof value !== 'undefined' ? value : defaultValue;
};

var toEventName = function toEventName(eventPath) {
  return eventPath.replace(/([A-Z])/g, ' $1').replace(/[.]/g, ' ').toLowerCase();
};

var isObject = function isObject(obj) {
  return obj && typeof obj === 'object';
};

function merge(target, source) {
  if (!isObject(target) || !isObject(source)) {
    return source;
  }

  Object.keys(source).forEach(function (key) {
    var targetValue = target[key];
    var sourceValue = source[key];

    if (Array.isArray(targetValue) && Array.isArray(sourceValue)) {
      target[key] = sourceValue;
    } else if (isObject(targetValue) && isObject(sourceValue)) {
      target[key] = merge(Object.assign({}, targetValue), sourceValue);
    } else {
      target[key] = sourceValue;
    }
  });
  return target;
}

function pick(obj, keys) {
  if (!isObject(obj) || !Array.isArray(keys)) {
    return {};
  }

  return Object.keys(obj).filter(function (i) {
    return keys.includes(i);
  }).reduce(function (acc, key) {
    acc[key] = obj[key];
    return acc;
  }, {});
}

function drop(obj, keys) {
  if (!isObject(obj)) {
    return {};
  }

  for (var _iterator = _createForOfIteratorHelperLoose(keys), _step; !(_step = _iterator()).done;) {
    var key = _step.value;
    delete obj[key];
  }

  return obj;
}

var ANALYTICS_DEFAULT_CONFIG = {
  logLevel: 1,
  serverUrl: 'https://api2.analyticspodium.com/2/httpapi'
};
var EXPERIMENT_DEFAULT_CONFIG = {
  serverUrl: 'https://lab.analyticspodium.com'
};
var AMPLITUDE_DEPRECATED_CONFIG_KEYS = ['includeReferrer', 'includeUtm', 'includeGclid', 'includeFbcli', 'batchEvents', 'saveEvents', 'eventUploadPeriodMillis'];

var TrackingClient = /*#__PURE__*/function () {
  function TrackingClient() {}

  var _proto = TrackingClient.prototype;

  _proto.init = function init(_ref) {
    var enabled = _ref.enabled,
        events = _ref.events,
        userGroupProperties = _ref.userGroupProperties,
        debug = _ref.debug,
        amplitudeConfig = _ref.amplitudeConfig,
        webAttributionPluginConfig = _ref.webAttributionPluginConfig,
        enableWebAttributionPlugin = _ref.enableWebAttributionPlugin,
        amplitudeToken = _ref.amplitudeToken,
        eventDataHook = _ref.eventDataHook;
    if (this._isInitialized) return;
    this._client = amplitude;
    this._userUid = null;
    this._events = withDefault(events, {});
    this._userGroupProperties = withDefault(userGroupProperties, []);
    this._enabled = withDefault(enabled, false);
    this._debug = withDefault(debug, false);
    this._eventDataHook = withDefault(eventDataHook, false);
    this._amplitudeConfig = this._getAmplitudeConfig(amplitudeConfig);
    this._enableWebAttributionPlugin = withDefault(enableWebAttributionPlugin, true);
    this._webAttributionPluginConfig = withDefault(webAttributionPluginConfig, {});

    this._client.init(amplitudeToken, null, this._amplitudeConfig);

    this._handlePageHide();

    this._addWebAttributionPlugin();

    this._isInitialized = true;
  };

  _proto.setUserUid = function setUserUid(userUid) {
    if (!this._userUid) {
      var _this$_amplitude;

      this._userUid = userUid;
      (_this$_amplitude = this._amplitude) === null || _this$_amplitude === void 0 ? void 0 : _this$_amplitude.setUserId(userUid);
    }
  };

  _proto.setUserProperties = function setUserProperties(userProperties) {
    var _this$_amplitude2;

    var identify = new amplitude.Identify();
    var userPropertiesEntries = Object.entries(userProperties);
    userPropertiesEntries.reduce(function (identify, _ref2) {
      var key = _ref2[0],
          value = _ref2[1];
      return identify.set(key, value);
    }, identify);
    (_this$_amplitude2 = this._amplitude) === null || _this$_amplitude2 === void 0 ? void 0 : _this$_amplitude2.identify(identify);
  };

  _proto.setUserProperty = function setUserProperty(property, value) {
    var _this$_amplitude3;

    var identify = new amplitude.Identify().set(property, value);
    (_this$_amplitude3 = this._amplitude) === null || _this$_amplitude3 === void 0 ? void 0 : _this$_amplitude3.identify(identify);
  };

  _proto.setOnceUserProperty = function setOnceUserProperty(property, value) {
    var _this$_amplitude4;

    var identify = new amplitude.Identify().setOnce(property, value);
    (_this$_amplitude4 = this._amplitude) === null || _this$_amplitude4 === void 0 ? void 0 : _this$_amplitude4.identify(identify);
  };

  _proto.setGroup = function setGroup(groupType, groupName) {
    var _this$_amplitude5;

    (_this$_amplitude5 = this._amplitude) === null || _this$_amplitude5 === void 0 ? void 0 : _this$_amplitude5.setGroup(groupType, groupName);
  };

  _proto.unsetUserProperty = function unsetUserProperty(property) {
    var _this$_amplitude6;

    var identify = new amplitude.Identify().unset(property);
    (_this$_amplitude6 = this._amplitude) === null || _this$_amplitude6 === void 0 ? void 0 : _this$_amplitude6.identify(identify);
  };

  _proto.appendUserProperty = function appendUserProperty(property, value) {
    var _this$_amplitude7;

    var identify = new amplitude.Identify().append(property, value);
    (_this$_amplitude7 = this._amplitude) === null || _this$_amplitude7 === void 0 ? void 0 : _this$_amplitude7.identify(identify);
  };

  _proto.prependUserProperty = function prependUserProperty(property, value) {
    var _this$_amplitude8;

    var identify = new amplitude.Identify().prepend(property, value);
    (_this$_amplitude8 = this._amplitude) === null || _this$_amplitude8 === void 0 ? void 0 : _this$_amplitude8.identify(identify);
  };

  _proto.addUserProperty = function addUserProperty(property, value) {
    var _this$_amplitude9;

    var identify = new amplitude.Identify().add(property, value);
    (_this$_amplitude9 = this._amplitude) === null || _this$_amplitude9 === void 0 ? void 0 : _this$_amplitude9.identify(identify);
  };

  _proto.removeUserProperty = function removeUserProperty(property, value) {
    var _this$_amplitude10;

    var identify = new amplitude.Identify().remove(property, value);
    (_this$_amplitude10 = this._amplitude) === null || _this$_amplitude10 === void 0 ? void 0 : _this$_amplitude10.identify(identify);
  };

  _proto.trackEvent = function trackEvent(eventPath, eventData, eventCallback) {
    var eventConfig = get(this._events, eventPath);

    var eventName = this._getEventName(eventPath);

    if (!this._isValidEvent(eventConfig, eventPath)) {
      eventCallback && eventCallback();
      return;
    }

    var eventProperties = this._attachEventMeta(eventPath, eventData);

    var groups = pick(eventProperties, this._userGroupProperties);
    var trackFn = null;

    if (Object.keys(groups).length) {
      var _this$_amplitude11;

      trackFn = (_this$_amplitude11 = this._amplitude) === null || _this$_amplitude11 === void 0 ? void 0 : _this$_amplitude11.track(eventName, eventProperties, {
        groups: groups
      });
    } else {
      var _this$_amplitude12;

      trackFn = (_this$_amplitude12 = this._amplitude) === null || _this$_amplitude12 === void 0 ? void 0 : _this$_amplitude12.track(eventName, eventProperties);
    }

    if (eventCallback) {
      var callbackFn = function callbackFn(result) {
        return eventCallback(result === null || result === void 0 ? void 0 : result.code, result === null || result === void 0 ? void 0 : result.message);
      };

      trackFn.promise.then(callbackFn)["catch"](callbackFn);
    }

    this._debugTrackEvent(eventName, eventProperties);
  };

  _proto.groupIdentify = function groupIdentify(groupType, groupName, property, value) {
    var _this$_amplitude13;

    var identify = new amplitude.Identify().set(property, value);
    (_this$_amplitude13 = this._amplitude) === null || _this$_amplitude13 === void 0 ? void 0 : _this$_amplitude13.groupIdentify(groupType, groupName, identify);
  };

  _proto.registerEvents = function registerEvents(events) {
    this.events = merge(this._events, events);
  };

  _proto._attachEventMeta = function _attachEventMeta(eventPath, eventData) {
    var _eventPath$split = eventPath.split('.'),
        product = _eventPath$split[0],
        source = _eventPath$split[1],
        action = _eventPath$split[2];

    var eventMeta = {
      product: product,
      source: source,
      action: action
    };
    var mergedData = Object.assign({}, eventData, eventMeta);

    if (this._eventDataHook !== false) {
      return this._eventDataHook(mergedData);
    } else {
      return mergedData;
    }
  };

  _proto._getEventName = function _getEventName(eventPath) {
    return get(this._events, eventPath) ? toEventName(eventPath) : undefined;
  };

  _proto._isValidEvent = function _isValidEvent(eventConfig, eventPath) {
    var isDefined = typeof eventConfig !== 'undefined';

    if (!isDefined) {
      this._log('error', "Invalid eventPath: " + eventPath);
    }

    var isEnabled = eventConfig === true;
    return isEnabled && isDefined;
  };

  _proto._isValidEventProps = function _isValidEventProps(eventName, eventPath) {
    var isValid = typeof eventName !== 'undefined';

    if (!isValid) {
      this._log('error', "Invalid eventPath: " + eventPath);
    }

    return isValid;
  };

  _proto._log = function _log(level, message) {
    if (this._debug) {
      console[level]("[TrackingClient] " + message);
    }
  };

  _proto._debugTrackEvent = function _debugTrackEvent(eventName, eventData) {
    if (this._debug) {
      var eventDataString = JSON.stringify(eventData || {});

      this._log('info', "Track event: " + eventName + " " + eventDataString);
    }
  };

  _proto._getAmplitudeConfig = function _getAmplitudeConfig(amplitudeConfig) {
    var config = Object.assign(ANALYTICS_DEFAULT_CONFIG, amplitudeConfig || {});

    var safeConfig = this._dropDeprecatedAmplitudeConfig(config);

    return safeConfig;
  };

  _proto._dropDeprecatedAmplitudeConfig = function _dropDeprecatedAmplitudeConfig(config) {
    var configKeysCount = Object.keys(config).length;
    var newConfig = drop(config, AMPLITUDE_DEPRECATED_CONFIG_KEYS);
    var newConfigKeysCount = Object.keys(newConfig).length;
    var hasDeprecatedKeys = configKeysCount !== newConfigKeysCount;

    if (hasDeprecatedKeys && !this._enabled) {
      console.warn('Tracking: You are using deprecated amplitudeConfig parameters');
    }

    return newConfig;
  };

  _proto._handlePageHide = function _handlePageHide() {
    if (this._enabled) {
      window.addEventListener('pagehide', function () {
        amplitude.setTransport('beacon');
        amplitude.flush();
      });
    }
  };

  _proto._addWebAttributionPlugin = function _addWebAttributionPlugin() {
    if (this._enableWebAttributionPlugin) {
      var config = this._webAttributionPluginConfig;
      amplitude.add(pluginWebAttributionBrowser.webAttributionPlugin(amplitude, config));
    }
  };

  _createClass(TrackingClient, [{
    key: "_amplitude",
    get: function get() {
      return this._enabled ? this._client : null;
    }
  }]);

  return TrackingClient;
}();

var tracking = new TrackingClient();
var TrackingContext = React.createContext({});

var useTrackingContext = function useTrackingContext(eventData) {
  var context = React.useContext(TrackingContext);
  var latestEventData = React.useRef(eventData);
  React.useEffect(function () {
    latestEventData.current = eventData;
  });
  var getContextData = React.useCallback(function () {
    var ownTrackingData = latestEventData.current || {};
    var contextData = context.getContextData ? context.getContextData() : {};
    return Object.assign({}, contextData, ownTrackingData);
  }, [context]);
  var trackEvent = React.useCallback(function (eventPath, data, eventCallback) {
    if (data === void 0) {
      data = {};
    }

    var mergedData = Object.assign({}, getContextData(), data);
    tracking.trackEvent(eventPath, mergedData, eventCallback);
  }, [getContextData]);
  return React.useMemo(function () {
    return {
      getContextData: getContextData,
      trackEvent: trackEvent
    };
  }, [getContextData, trackEvent]);
};

var useTracking = function useTracking(eventData) {
  var trackingContext = useTrackingContext(eventData);
  var Track = React.useCallback(function (_ref) {
    var children = _ref.children;
    return /*#__PURE__*/React__default.createElement(TrackingContext.Provider, {
      value: trackingContext
    }, children);
  }, [trackingContext]);
  return React.useMemo(function () {
    return {
      Track: Track,
      trackEvent: trackingContext.trackEvent,
      getContextData: trackingContext.getContextData
    };
  }, [trackingContext, Track]);
};

var _excluded = ["forwardedRef"];

var withTracking = function withTracking(WrappedComponent, eventData) {
  var WithTracking = function WithTracking(_ref) {
    var forwardedRef = _ref.forwardedRef,
        props = _objectWithoutPropertiesLoose(_ref, _excluded);

    var _useTracking = useTracking(eventData),
        trackEvent = _useTracking.trackEvent,
        Track = _useTracking.Track;

    return /*#__PURE__*/React__default.createElement(Track, null, /*#__PURE__*/React__default.createElement(WrappedComponent, _extends({
      ref: forwardedRef,
      trackEvent: trackEvent
    }, props)));
  };

  return React__default.forwardRef(function (props, ref) {
    return /*#__PURE__*/React__default.createElement(WithTracking, _extends({
      forwardedRef: ref
    }, props));
  });
};

var _navigator;

var isProd = function isProd() {
  return process.env.NODE_ENV === 'production';
};

var defaultEnabled = typeof navigator === 'undefined' ? true : isProd() && ((_navigator = navigator) === null || _navigator === void 0 ? void 0 : _navigator.userAgent) !== 'qa-automation-bot';

var ExperimentClient = /*#__PURE__*/function () {
  function ExperimentClient() {}

  var _proto = ExperimentClient.prototype;

  _proto.init = function init(_ref) {
    var _this$_instance,
        _this = this;

    var connectToAnalytics = _ref.connectToAnalytics,
        debug = _ref.debug,
        enabled = _ref.enabled,
        environmentKey = _ref.environmentKey,
        experimentUser = _ref.experimentUser,
        amplitudeConfig = _ref.amplitudeConfig;
    if (this._instance) return;
    this._loading = true;
    this._enabled = enabled || defaultEnabled;
    this._debug = debug || false;
    this._amplitudeConfig = this._getAmplitudeConfig(amplitudeConfig);
    this._client = connectToAnalytics ? experimentJsClient.Experiment.initializeWithAmplitudeAnalytics(environmentKey, this._amplitudeConfig) : experimentJsClient.Experiment.initialize(environmentKey, this._amplitudeConfig);
    this._fetchFn = (_this$_instance = this._instance) === null || _this$_instance === void 0 ? void 0 : _this$_instance.fetch(experimentUser).then(function () {
      _this._loading = false;
    });
  };

  _proto.variant = function variant(experimentName) {
    var _this$_instance2;

    return (_this$_instance2 = this._instance) === null || _this$_instance2 === void 0 ? void 0 : _this$_instance2.variant(experimentName);
  };

  _proto.fetch = function fetch(properties) {
    var _this$_instance3;

    return (_this$_instance3 = this._instance) === null || _this$_instance3 === void 0 ? void 0 : _this$_instance3.fetch(properties);
  };

  _proto._getAmplitudeConfig = function _getAmplitudeConfig(amplitudeConfig) {
    var config = Object.assign(EXPERIMENT_DEFAULT_CONFIG, amplitudeConfig || {});

    if (config.debug === null) {
      config.debug = this._debug;
    }

    return config;
  };

  _createClass(ExperimentClient, [{
    key: "_instance",
    get: function get() {
      return this._enabled ? this._client : null;
    }
  }, {
    key: "isLoading",
    get: function get() {
      return this._enabled ? this._loading : false;
    }
  }]);

  return ExperimentClient;
}();

var experiment = new ExperimentClient();

var useExperiment = function useExperiment(experimentName) {
  var variant = experiment.variant(experimentName);

  var _useState = React.useState(experiment.isLoading),
      isLoading = _useState[0],
      setIsLoading = _useState[1];

  var _useState2 = React.useState(variant === null || variant === void 0 ? void 0 : variant.value),
      value = _useState2[0],
      setValue = _useState2[1];

  var _useState3 = React.useState(variant === null || variant === void 0 ? void 0 : variant.payload),
      payload = _useState3[0],
      setPayload = _useState3[1];

  React.useEffect(function () {
    var isSubscribed = true;

    if (experiment.isLoading) {
      var waitUntilFetched = function waitUntilFetched() {
        try {
          return Promise.resolve(experiment._fetchFn).then(function () {
            if (isSubscribed) {
              var _variant = experiment.variant(experimentName);

              setIsLoading(experiment.isLoading);
              setValue(_variant === null || _variant === void 0 ? void 0 : _variant.value);
              setPayload(_variant === null || _variant === void 0 ? void 0 : _variant.payload);
            }
          });
        } catch (e) {
          return Promise.reject(e);
        }
      };

      waitUntilFetched();
    }

    return function () {
      return isSubscribed = false;
    };
  }, []);
  return [isLoading, value, payload];
};

var useFlag = useExperiment;

var useMultipleExperiments = function useMultipleExperiments(experiments) {
  if (experiments === void 0) {
    experiments = [];
  }

  var experimentResults = experiments.reduce(function (acc, experimentName) {
    var _extends2;

    return _extends({}, acc, (_extends2 = {}, _extends2[experimentName] = experiment.variant(experimentName), _extends2));
  }, {});
  return experiment.isLoading ? [true, {}] : [false, experimentResults];
};

exports.experiment = experiment;
exports.tracking = tracking;
exports.useExperiment = useExperiment;
exports.useFlag = useFlag;
exports.useMultipleExperiments = useMultipleExperiments;
exports.useTracking = useTracking;
exports.withTracking = withTracking;